import { LeaderboardSchedule } from '@repo/database/src/types';

export interface LeaderboardScheduleInfo {
  id: string;
  cronString: string;
  description: string | null;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string | null;
  nextEndDate: Date | null;
  previousEndDate: Date | null;
}

export interface UpdateLeaderboardScheduleBody {
  cronString: string;
  description?: string;
}

export enum CronSchedulePreset {
  EVERY_1_MINUTE = 'Every 1 minute',
  EVERY_3_MINUTES = 'Every 3 minutes',
  EVERY_5_MINUTES = 'Every 5 minutes',
  EVERY_10_MINUTES = 'Every 10 minutes',
  EVERY_15_MINUTES = 'Every 15 minutes',
  EVERY_20_MINUTES = 'Every 20 minutes',
  EVERY_30_MINUTES = 'Every 30 minutes',
  EVERY_1_HOUR = 'Every 1 hour',
  EVERY_2_HOURS = 'Every 2 hours',
  EVERY_5_HOURS = 'Every 5 hours',
  EVERY_12_HOURS = 'Every 12 hours',
  EVERY_1_DAY = 'Every 1 day',
  EVERY_7_DAYS = 'Every 7 days',
  EVERY_WEEK_MONDAY_NOON = 'Every Monday at noon UTC (default)',
}

export const CronScheduleMap: Record<CronSchedulePreset, string> = {
  [CronSchedulePreset.EVERY_1_MINUTE]: '* * * * *',
  [CronSchedulePreset.EVERY_3_MINUTES]: '*/3 * * * *',
  [CronSchedulePreset.EVERY_5_MINUTES]: '*/5 * * * *',
  [CronSchedulePreset.EVERY_10_MINUTES]: '*/10 * * * *',
  [CronSchedulePreset.EVERY_15_MINUTES]: '*/15 * * * *',
  [CronSchedulePreset.EVERY_20_MINUTES]: '*/20 * * * *',
  [CronSchedulePreset.EVERY_30_MINUTES]: '*/30 * * * *',
  [CronSchedulePreset.EVERY_1_HOUR]: '0 * * * *',
  [CronSchedulePreset.EVERY_2_HOURS]: '0 */2 * * *',
  [CronSchedulePreset.EVERY_5_HOURS]: '0 */5 * * *',
  [CronSchedulePreset.EVERY_12_HOURS]: '0 */12 * * *',
  [CronSchedulePreset.EVERY_1_DAY]: '0 0 * * *',
  [CronSchedulePreset.EVERY_7_DAYS]: '0 0 * * 0',
  [CronSchedulePreset.EVERY_WEEK_MONDAY_NOON]: '0 12 * * 1',
};

export type LeaderboardScheduleResponse = LeaderboardSchedule;
